export default __webpack_public_path__ + "static/media/ui_charts.de6ab4e1.png";